import { render, staticRenderFns } from "./BasePillsLikeTabBar.vue?vue&type=template&id=7f46571a&scoped=true"
import script from "./BasePillsLikeTabBar.vue?vue&type=script&lang=js"
export * from "./BasePillsLikeTabBar.vue?vue&type=script&lang=js"
import style0 from "./BasePillsLikeTabBar.vue?vue&type=style&index=0&id=7f46571a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f46571a",
  null
  
)

export default component.exports